import proj4 from 'proj4'

proj4.defs('EPSG:3857', '+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext +no_defs')

export const CRSManager = {
  supported: ['EPSG:4326', 'EPSG:3857'],
  transformCoordinate(coordinate, source, destination) {
    if (source === destination) return coordinate
    return proj4(source, destination, coordinate)
  },
  normalize(value) {
    if (!value) return 'EPSG:4326'
    const epsg = String(value).toUpperCase().match(/EPSG[:/](\d+)/)
    return epsg ? `EPSG:${epsg[1]}` : value
  }
}
